import { j as r } from "./atoms-v218.js";
import { forwardRef as w, useState as y } from "react";
import { InputContainer as D } from "./atoms-v2114.js";
import { InputHelper as f } from "./atoms-v220.js";
import { InputInterior as F } from "./atoms-v2128.js";
import { InputOutline as v } from "./atoms-v223.js";
import { Input as $ } from "./atoms-v2867.js";
import { DigitInputSkeleton as B } from "./atoms-v2868.js";
const M = w(
  ({
    className: a = "",
    disabled: l = !1,
    error: x,
    helperText: m,
    isError: n = !1,
    isSkeleton: j = !1,
    onChange: o,
    value: I,
    variant: u = "productive",
    ...e
  }, g) => {
    const [b, c] = y(!1), h = (i) => {
      const t = i.target.value.slice(-1), d = { ...i };
      (/^[0-9]$/.test(t) || t === "") && (Object.defineProperty(d, "target", {
        value: { ...i.target, value: t },
        writable: !0
      }), o == null || o(d));
    };
    if (j)
      return /* @__PURE__ */ r.jsx(B, { className: a, helperText: m, variant: u });
    const s = e.name ? `${e.name}_errormessage` : void 0;
    return /* @__PURE__ */ r.jsxs(D, { className: a, variant: u, children: [
      /* @__PURE__ */ r.jsx(v, { isDisabled: l, isErrored: n, isFocused: b, variant: u, children: /* @__PURE__ */ r.jsx(F, { children: /* @__PURE__ */ r.jsx(
        $,
        {
          ...e,
          $variant: u,
          "aria-invalid": n,
          disabled: l,
          inputMode: "numeric",
          maxLength: 1,
          onBlur: (i) => {
            var t;
            c(!1), (t = e.onBlur) == null || t.call(e, i);
          },
          onChange: h,
          onFocus: (i) => {
            var t;
            c(!0), (t = e.onFocus) == null || t.call(e, i);
          },
          pattern: "[0-9]*",
          ref: g,
          type: "text",
          value: I,
          ...n && s && { "aria-describedby": s }
        }
      ) }) }),
      /* @__PURE__ */ r.jsx(f, { children: !n && m }),
      /* @__PURE__ */ r.jsx(f, { isError: !0, id: s, children: x })
    ] });
  }
);
M.displayName = "DigitInput";
export {
  M as DigitInput
};
